export interface ClientEvent {
  id: number;
  company: string;
  logo: string;
  image?: string; // Ruta opcional a la imagen del evento
  imageAlt?: string; // Texto alternativo descriptivo para la imagen
  years: number[];
  locations?: string[];
  description: string;
}

export const clientEvents: ClientEvent[] = [
  {
    id: 1,
    company: 'ALVARO DIAZ',
    logo: '🎤',
    image: '/client/events/alvaro_mgzehus7bdbbh.webp',
    years: [2025],
    locations: ['Medellín'],
    description: 'Concierto del artista puertorriqueño de trap y R&B'
  },
  {
    id: 2,
    company: '&ME',
    logo: '🎧',
    image: '/client/events/&ME_mgzehus71ccgv.webp',
    years: [2025],
    locations: ['Medellín'],
    description: 'Productor alemán de música electrónica house y techno'
  },
  {
    id: 3,
    company: 'CORE',
    logo: '🎵',
    image: '/client/events/core_mgzehusdtrcc1.webp',
    years: [2025, 2024],
    locations: ['Medellín'],
    description: 'Festival de música electrónica'
  },
  {
    id: 4,
    company: 'Feria de Manizales',
    logo: '🎪',
    image: '/client/events/feria-manizales_mgzehuslhdajc.webp',
    years: [2025],
    description: 'Una de las ferias más importantes de Colombia'
  },
  {
    id: 5,
    company: 'Feria de las Flores',
    logo: '🌺',
    image: '/client/events/feria-flores_mgzehuslzvzbk.webp',
    years: [2024, 2023, 2022, 2021],
    locations: ['Medellín'],
    description: 'La feria más representativa de Medellín'
  },
  {
    id: 6,
    company: 'RANCHETON ARENA MIX',
    logo: '🤠',
    image: '/client/events/rancheton_mgzeicb9piqk8.webp',
    years: [],
    locations: ['Cundinamarca'],
    description: 'Festival de música popular y ranchera'
  },
  {
    id: 7,
    company: 'DOOM',
    logo: '🎸',
    image: '/client/events/dom_mgzehusiuum7g.webp',
    years: [2024],
    locations: ['Bogotá'],
    description: 'Festival de música metal y rock pesado'
  },
  {
    id: 8,
    company: 'CARL COX',
    logo: '🎛️',
    image: '/client/events/carl-cox_mgzehuscm3g5h.webp',
    years: [2024],
    locations: ['Medellín'],
    description: 'DJ y productor británico legendario de techno'
  },
  {
    id: 9,
    company: 'La Solar',
    logo: '☀️',
    image: '/client/events/la-solar_mgzeicb9kg1v9.webp',
    years: [2024],
    locations: ['Medellín'],
    description: 'Festival de música electrónica'
  },
  {
    id: 10,
    company: 'RITVALES',
    logo: '🎭',
    image: '/client/events/ritvales 2023_mgzeicb9a573a.webp',
    years: [2023],
    locations: ['Medellín'],
    description: 'Festival de música y arte alternativo'
  },
  {
    id: 11,
    company: 'JAZZ al Parque',
    logo: '🎺',
    image: '/client/events/jazz al parque bogota 2023_mgzehusodkv3c.webp',
    years: [2023, 2022, 2019],
    description: 'Festival gratuito de jazz en Bogotá'
  },
  {
    id: 12,
    company: 'F-AIR COLOMBIA',
    logo: '✈️',
    image: '/client/events/FAIR-colombia 2023_mgzehusl4lw9b.webp',
    years: [2023],
    description: 'Feria de la Industria Aeronáutica'
  },
  {
    id: 13,
    company: 'Joropo al Parque',
    logo: '🪕',
    image: '/client/events/joropo al parque 2023_mgzeicb43t1wo.webp',
    years: [2023],
    description: 'Festival de música llanera y joropo'
  },
  {
    id: 14,
    company: 'Salsa al Parque',
    logo: '💃',
    image: '/client/events/salsa al parque 2023_mgzeicbd6tblr.webp',
    years: [2023, 2022, 2019],
    description: 'Festival gratuito de salsa en Bogotá'
  },
  {
    id: 15,
    company: 'Rock al Parque',
    logo: '🎸',
    image: '/client/events/rock al parque 2022_mgzeicbcm5j89.webp',
    years: [2022, 2019],
    description: 'Uno de los festivales gratuitos de rock más grandes de Latinoamérica'
  },
  {
    id: 16,
    company: 'EXPO CUNDINAMARCA',
    logo: '🏭',
    image: '/client/events/expo cundinamarca 2022_mgzehusixkp5l.webp',
    years: [2022],
    description: 'Exposición comercial e industrial de Cundinamarca'
  },
  {
    id: 17,
    company: 'Hip Hop al Parque',
    logo: '🎤',
    image: '/client/events/hiphop al parque 2022_mgzehusltv6xp.webp',
    years: [2022, 2019],
    description: 'Festival gratuito de hip hop en Bogotá'
  },
  {
    id: 18,
    company: 'Desfile Autos Clásicos',
    logo: '🚗',
    image: '/client/events/desfile autos clasicos medellin 2022_mgzehusf8f3hh.webp',
    years: [2022],
    locations: ['Medellín'],
    description: 'Exhibición de automóviles clásicos y antiguos'
  },
  {
    id: 19,
    company: 'La Gira Alejandro Sanz',
    logo: '🎤',
    image: '/client/events/la gira alejandro sanz 2022_mgzeicb892slb.webp',
    years: [2022],
    locations: ['Cali'],
    description: 'Concierto del cantautor español'
  },
  {
    id: 20,
    company: 'SODA STEREO',
    logo: '🎸',
    image: '/client/events/soda estereo 2020_mgzeicbf0ibnb.webp',
    years: [2020],
    description: 'Gira tributo a la icónica banda argentina'
  },
  {
    id: 21,
    company: 'BEYOND WONDERLAND',
    logo: '🎪',
    image: '/client/events/21-beyond-wonderland_mgzeiunzchkh1.webp',
    years: [2019],
    description: 'Festival de música electrónica'
  },
  {
    id: 22,
    company: 'FOO FIGHTERS',
    logo: '🥁',
    image: '/client/events/22-foo-fighters_mgzeiuo5ijpjs.webp',
    years: [2019],
    description: 'Concierto de la banda estadounidense de rock alternativo'
  },
  {
    id: 23,
    company: 'Festival Tatacoa',
    logo: '🏜️',
    image: '/client/events/23-tatacoa-fes_mgzeiuoa42vuu.webp',
    years: [2019],
    description: 'Festival en el desierto de La Tatacoa'
  },
  {
    id: 24,
    company: 'Picnic de Andrés',
    logo: '🎻',
    image: '/client/events/24-picnic-andres_mgzeiuocydyef.webp',
    years: [2019, 2018, 2017],
    description: 'Festival de música del cantautor colombiano Andrés Cepeda'
  },
  {
    id: 25,
    company: 'Colombia al Parque',
    logo: '🇨🇴',
    image: '/client/events/25-colombia-alparque_mgzeiuoeb94ex.webp',
    years: [2019],
    description: 'Festival cultural y musical gratuito'
  },
  {
    id: 26,
    company: 'Festival de Verano Bogotá',
    logo: '☀️',
    image: '/client/events/26-fest-verano-bog_mgzeiuohd4ysx.webp',
    years: [2019, 2017, 2016, 2015],
    description: 'Festival de verano en la capital colombiana'
  },
  {
    id: 27,
    company: 'Luis Miguel - México por Siempre',
    logo: '🎤',
    image: '/client/events/27-luis-miguel_mgzeiuoittg2n.webp',
    years: [2019],
    description: 'Gira del cantante mexicano'
  },
  {
    id: 28,
    company: 'STEREO PICNIC',
    logo: '🎵',
    image: '/client/events/28-estereo-picnic_mgzeiuokz9nhh.webp',
    years: [2018],
    description: 'Festival Estéreo Picnic, el festival más grande de Colombia'
  },
  {
    id: 29,
    company: 'I Love Bogotá',
    logo: '❤️',
    image: '/client/events/29-i-lovelbogta_mgzeiuombpv4x.webp',
    years: [2018],
    description: 'Festival de celebración de la ciudad de Bogotá'
  },
  {
    id: 30,
    company: 'Shakira - El Dorado World Tour',
    logo: '💃',
    image: '/client/events/30-shakira_mgzeiuopvi4tn.webp',
    years: [2018],
    description: 'Gira mundial de la artista colombiana'
  },
  {
    id: 31,
    company: 'Festival Be You Fest',
    logo: '🎭',
    image: '/client/events/31-be-fest_mgzeiuopuwthi.webp',
    years: [2018],
    description: 'Festival de diversidad y expresión artística'
  },
  {
    id: 32,
    company: 'Visita del Papa Francisco',
    logo: '✝️',
    image: '/client/events/32-papa-francisco_mgzeiuoqxy1ng.webp',
    years: [2017],
    locations: ['Bogotá'],
    description: 'Visita papal a Colombia'
  },
  {
    id: 33,
    company: 'Jamming Summer Fest',
    logo: '🎸',
    image: '/client/events/33-jamming_mgzeiuorhmse5.webp',
    years: [2017],
    description: 'Festival de música de verano'
  }
];
